import { Box, IconButton, Link, Typography } from '@mui/material'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import GitHubIcon from '@mui/icons-material/GitHub'
import EmailIcon from '@mui/icons-material/Email'
import { Link as RouterLink } from 'react-router-dom'
import Logo from './shared/Logo'
import { Container } from './shared/Section'
import { COLORS, SITE } from '../constants'
import { services } from '../utils/siteContent'

const linkSx = { color: COLORS.mutedOnDark, textDecoration: 'none', fontSize: '0.95rem', '&:hover': { color: COLORS.white } }
const headingSx = { color: COLORS.white, fontWeight: 700, fontSize: '0.8rem', letterSpacing: '0.14em', textTransform: 'uppercase' as const, mb: 2 }

function Footer() {
    return (
        <Box component="footer" sx={{ backgroundColor: COLORS.black, color: COLORS.mutedOnDark, borderTop: `1px solid ${COLORS.blackBorder}`, pt: { xs: 7, md: 9 }, pb: 4 }}>
            <Container>
                <Box sx={{ display: 'grid', gap: 5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1.6fr 1fr 1fr 1fr' } }}>
                    <Box>
                        <Logo size="md" showTagline />
                        <Typography sx={{ mt: 3, maxWidth: 340, fontSize: '0.95rem' }}>
                            Freelance software engineering, automation and AWS consulting.
                            Based in {SITE.location}, working with teams anywhere.
                        </Typography>
                        <Box sx={{ mt: 2, ml: -1 }}>
                            <IconButton href={SITE.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" sx={{ color: COLORS.mutedOnDark, '&:hover': { color: COLORS.accent } }}><LinkedInIcon /></IconButton>
                            <IconButton href={SITE.github} target="_blank" rel="noreferrer" aria-label="GitHub" sx={{ color: COLORS.mutedOnDark, '&:hover': { color: COLORS.accent } }}><GitHubIcon /></IconButton>
                            <IconButton href={`mailto:${SITE.email}`} aria-label="Email" sx={{ color: COLORS.mutedOnDark, '&:hover': { color: COLORS.accent } }}><EmailIcon /></IconButton>
                        </Box>
                    </Box>

                    <Box>
                        <Typography sx={headingSx}>Services</Typography>
                        <Box sx={{ display: 'grid', gap: 1.25 }}>
                            {services.map((s) => (
                                <Link key={s.id} component={RouterLink} to={s.id === 'mentorship' ? '/mentorship' : `/services#${s.id}`} sx={linkSx}>{s.shortTitle}</Link>
                            ))}
                        </Box>
                    </Box>

                    <Box>
                        <Typography sx={headingSx}>Site</Typography>
                        <Box sx={{ display: 'grid', gap: 1.25 }}>
                            <Link component={RouterLink} to="/work" sx={linkSx}>Work &amp; Case Studies</Link>
                            <Link component={RouterLink} to="/mentorship" sx={linkSx}>Mentorship</Link>
                            <Link component={RouterLink} to="/resume" sx={linkSx}>Resume</Link>
                            <Link component={RouterLink} to="/contact" sx={linkSx}>Contact</Link>
                        </Box>
                    </Box>

                    <Box>
                        <Typography sx={headingSx}>Get in touch</Typography>
                        <Link href={`mailto:${SITE.email}`} sx={{ ...linkSx, color: COLORS.accent, wordBreak: 'break-all' }}>{SITE.email}</Link>
                        <Typography sx={{ mt: 1.5, fontSize: '0.95rem' }}>{SITE.location}</Typography>
                    </Box>
                </Box>

                <Box sx={{ mt: 7, pt: 3, borderTop: `1px solid ${COLORS.blackBorder}`, display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', fontSize: '0.85rem' }}>
                    <Typography sx={{ fontSize: 'inherit' }}>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</Typography>
                    <Typography sx={{ fontSize: 'inherit' }}>{SITE.manualTagline} <Box component="span" sx={{ color: COLORS.accent }}>{SITE.manualPunchline}</Box></Typography>
                </Box>
            </Container>
        </Box>
    )
}
export default Footer
